module.exports = __webpack_public_path__ + "static/add_vueminder-059dd86fe5c7575665a71590c6926da8.png";